/**
 * Parse scoreType string to extract type and configuration
 * @param {string} scoreType - The scoreType string (e.g., 'int[2]', 'time')
 * @returns {object|null} Parsed score type info or null
 */
export const parseScoreType = (scoreType) => {
    if (!scoreType) return null;
    
    // Parse the main type
    if (scoreType.startsWith('int[')) {
        const match = scoreType.match(/int\[(\d+)\]/);
        return {
            type: 'int',
            digits: match ? parseInt(match[1]) : 2
        };
    } else if (scoreType === 'time') {
        return {
            type: 'time'
        };
    }
    
    return null;
};

/**
 * Convert seconds (integer) to MM:SS format string.
 *
 * Only 'X' means a failed puzzle. An absent score is not a failure - a play row
 * with a null score is written on every game-link click, so treating null as
 * 'X' made the score form open pre-filled with a failure the user never
 * entered. Callers that want to show something for an absent score check for
 * one themselves.
 *
 * @param {number|string} seconds - The number of seconds or 'X' for failed puzzles
 * @returns {string} Time in MM:SS format or 'X'
 */
export const secondsToTimeString = (seconds) => {
    if (seconds === 'X') {
        return 'X';
    }
    if (seconds === null || seconds === undefined || seconds === '') {
        return "00:00";
    }

    const totalSeconds = parseInt(seconds, 10);
    if (isNaN(totalSeconds)) {
        return "00:00";
    }
    
    const minutes = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Convert MM:SS format string to seconds (integer)
 * @param {string} timeString - Time in MM:SS format or 'X' for failed puzzles
 * @returns {number|string} Total seconds as integer or 'X'
 */
export const timeStringToSeconds = (timeString) => {
    if (timeString === 'X') {
        return 'X';
    }
    
    if (!timeString || timeString === "00:00") {
        return 0;
    }
    
    const [minutes, seconds] = timeString.split(':').map(v => parseInt(v, 10));
    return minutes * 60 + seconds;
};